import React from "react";
import { all_routes } from "../../../router/all_routes";
import { Link, useParams } from "react-router-dom";
import { useGetStudentByIdQuery } from "../api/studentApi";
import { encryptId } from "../../../../core/utils/crypto";
import { showToast } from "../../../../core/utils/alert";

const StudentBreadcrumb: React.FC<{ studentId?: string, studentStatus?: string }> = ({ studentId, studentStatus }) => {
  const routes = all_routes;
  const { id } = useParams<{ id: string }>();
  const { data: studentResponse, isLoading } = useGetStudentByIdQuery({ id: id || studentId || "" });
  const student = studentResponse?.data?.student;
  return (
    <div className="col-md-12"> 
      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        <div className="my-auto mb-2">
          <h3 className="page-title mb-1">Student Details</h3>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.adminDashboard}>Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={routes.studentList}>Student</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Student Details
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <Link
            to="#"
            className="btn btn-light me-2 mb-2"
            data-bs-toggle="modal"
            data-bs-target="#login_detail"
          >
            <i className="ti ti-lock me-2" />
            Login Details
          </Link>
          {(id || studentId) && (
            <Link
              to={`${routes.editStudent.replace(":id", id || studentId || "")}`}
              className="btn btn-primary d-flex align-items-center mb-2"
            >
              <i className="ti ti-edit me-2" />
              Edit Student
            </Link>
          )}
        </div>
      </div>

      {/* Registration Link Alert Banner */}
      {!isLoading && student && student?.reg_status === 'in_progress' && (
        <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4" style={{ borderLeft: '4px solid #ff9f43' }}>
          <div className="d-flex align-items-center">
            <i className="ti ti-alert-circle fs-4 me-2 text-warning"></i>
            <div>
              <strong className="text-dark">Incomplete Registration:</strong>{" "}
              <span className="text-dark">This student's profile is incomplete. Share this link to let them finish registration.</span>
            </div>
          </div>
          <div className="d-flex gap-2 align-items-center w-100 mt-2 mt-md-0" style={{ maxWidth: '400px' }}>
            <div className="input-group input-group-sm w-100">
              <input
                type="text"
                className="form-control bg-white"
                value={`${window.location.origin}/complete-registration/${encryptId(id || studentId || "")}`}
                readOnly
              />
              <button
                className="btn btn-outline-primary bg-white"
                type="button"
                title="Copy Link"
                onClick={() => {
                  const url = `${window.location.origin}/complete-registration/${encryptId(id || studentId || "")}`;
                  navigator.clipboard.writeText(url);
                  showToast({ text: "Link copied to clipboard!", icon: "success" });
                }}
              >
                <i className="ti ti-copy"></i>
              </button>
              <button
                className="btn btn-outline-success bg-white"
                type="button"
                title="Share via WhatsApp"
                onClick={() => {
                  const url = `${window.location.origin}/complete-registration/${encryptId(id || studentId || "")}`;
                  const text = encodeURIComponent(`Please click the link to complete your student registration:\n\n${url}`);
                  window.open(`https://wa.me/?text=${text}`, '_blank');
                }}
              >
                <i className="ti ti-brand-whatsapp"></i>
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default StudentBreadcrumb;
